import {
  Pipe,
  PipeTransform
} from '@angular/core';
@Pipe({
  name: 'splitpipe'
})
export class SplitPipe implements PipeTransform {


  transform(value: string, splitbychar: string): any {
    if (!value) return value;
    return value.split(splitbychar);
   

  }
} 
